module.exports = __webpack_public_path__ + "img/banner-iptu-sm-2022.89e7e373.jpg";